import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
// You'll need to replace these with your actual Firebase project config
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAouL7nYIS7uFxKpQd3rK1RNHsn8dLwC6g",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "ectd-viewer.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "ectd-viewer",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "ectd-viewer.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1034957458073",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:1034957458073:web:761ca07fdbab22135ec608"
};

// Debug environment variables
console.log('Firebase Config Debug:');
console.log('API Key:', import.meta.env.VITE_FIREBASE_API_KEY ? 'Present' : 'Missing');
console.log('Project ID:', import.meta.env.VITE_FIREBASE_PROJECT_ID ? 'Present' : 'Missing');
console.log('Auth Domain:', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ? 'Present' : 'Missing');
console.log('Full Config:', firebaseConfig);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Emulator connection disabled by default; enable when needed.

export default app;
